import { render, staticRenderFns } from "./KakaoMessageTemplateSetting.vue?vue&type=template&id=0bce6a64&scoped=true"
import script from "./KakaoMessageTemplateSetting.vue?vue&type=script&lang=js"
export * from "./KakaoMessageTemplateSetting.vue?vue&type=script&lang=js"
import style0 from "./KakaoMessageTemplateSetting.vue?vue&type=style&index=0&id=0bce6a64&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bce6a64",
  null
  
)

export default component.exports